import { Children, cloneElement, isValidElement, useEffect, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Tabs = ({
  children,
  className,
  initialTabIndex = 0,
  ...rest
}) => {
  const [activeTabIndex, setActiveTabIndex] = useState(initialTabIndex);
  useEffect(() => {
    setActiveTabIndex(initialTabIndex);
  }, [initialTabIndex]);
  const handleTabClick = tabIndex => {
    setActiveTabIndex(tabIndex);
  };
  const renderTabsList = () => {
    return Children.map(children, (child, index) => {
      return /*#__PURE__*/isValidElement(child) ? /*#__PURE__*/cloneElement(child, {
        onClick: handleTabClick,
        tabIndex: index,
        isActive: index === activeTabIndex
      }) : null;
    });
  };
  const renderActiveTabContent = () => {
    if (children[activeTabIndex]) {
      return children[activeTabIndex].props.children;
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    className: `Tabs ${className}`,
    ...rest,
    "data-sentry-component": "Tabs",
    "data-sentry-source-file": "TabVertical.tsx",
    children: [/*#__PURE__*/_jsx("ul", {
      className: "Tabs_nav",
      children: renderTabsList()
    }), /*#__PURE__*/_jsx("div", {
      className: "Tabs_activeContent",
      children: renderActiveTabContent()
    })]
  });
};
const Tab = ({
  isActive,
  onClick,
  tabIndex,
  tabContent
}) => {
  const handleTabClick = event => {
    event.preventDefault();
    onClick(tabIndex);
  };
  return /*#__PURE__*/_jsx("li", {
    className: `Tab ${isActive ? 'isActive' : ''}`,
    onClick: handleTabClick,
    "data-sentry-component": "Tab",
    "data-sentry-source-file": "TabVertical.tsx",
    children: tabContent
  });
};
export { Tabs, Tab };